<template>
    <DModal
        :title="showModal ? $t('certificates.download_modal_title', { domain: showDetails.domain }) : ''"
        :show="showModal"
        @close="$emit('close-download-modal')"
    >
        <div
            v-if="showModal"
            class="padding"
        >
            <DRow>
                <DCol sm="4">
                    <label class="font-weight-bold">{{ $t('certificates.download_expires_label') }}</label>
                </DCol>
                <DCol sm="8">
                    <DInput
                        :value="$formatDateTime(showDetails.expiresAt)"
                        add-input-classes="bg-light"
                        :disabled="true"
                    />
                </DCol>
            </DRow>
            <DRow class="mt-3">
                <DCol sm="12">
                    <div class="download-actions">
                        <DButton
                            :href="$route('certificates.download-file', { certificate: showDetails.id, type: 'cert' })"
                            target="_self"
                            icon="download"
                            :label="$t('certificates.download_cert')"
                            mini
                        />
                        <DButton
                            v-if="showDetails.caCert"
                            :href="$route('certificates.download-file', { certificate: showDetails.id, type: 'chain' })"
                            target="_self"
                            icon="download"
                            :label="$t('certificates.download_chain')"
                            mini
                        />
                        <DButton
                            v-if="showDetails.caCert"
                            :href="$route('certificates.download-file', { certificate: showDetails.id, type: 'fullchain' })"
                            target="_self"
                            icon="download"
                            :label="$t('certificates.download_fullchain')"
                            mini
                        />
                        <DButton
                            v-if="showDetails.privateKey"
                            :href="$route('certificates.download-file', { certificate: showDetails.id, type: 'key' })"
                            target="_self"
                            icon="download"
                            :label="$t('certificates.download_key')"
                            mini
                        />
                        <DButton
                            icon="download"
                            :label="$t('certificates.download_all')"
                            mini
                            :disabled="!showDetails.cert"
                            @click="downloadAllFiles"
                        />
                    </div>
                </DCol>
            </DRow>
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'CertificateDownloadModal',
    props: {
        showDetails: {
            type: Object,
            default: () => {
                return {}
            }
        },
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-download-modal'],
    methods: {
        downloadAllFiles () {
            window.location.href = this.$route('certificates.download-files', { certificate: this.showDetails.id })
        }
    }
}
</script>

<style scoped>
.padding {
    padding: 20px;
}
.download-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
}
</style>
